import React from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { getBrand } from 'ctm-app/client/store/selectors';

const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: ${(props) => props.margin};
    background-color: ${(props) => props.bgColor};
    padding-top: 1.6rem;
    padding-bottom: 1.6rem;
    img {
        height: ${(props) => (props.isXs ? '3.2rem' : '4rem')};
    }
`;

const ElevenMonthHeader = (props) => {
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';
    const { src, bgColor, alt, margin } = props;

    const brandCode = useSelector((state) => getBrand(state));

    return (
        brandCode !== 'islt'
            && (
                <HeaderWrapper data-id="header-wrapper"
                    bgColor={bgColor}
                    isXs={isXs}
                    margin={margin}
                >
                    <img
                        src={src}
                        alt={alt}
                    />
                </HeaderWrapper>
            )
    );
};

ElevenMonthHeader.propTypes = {
    src: PropTypes.string,
    bgColor: PropTypes.string,
    alt: PropTypes.string,
    margin: PropTypes.string
};

export { ElevenMonthHeader };
